<section id="content" class="qualified-teacher-view" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.qualifiedTeacherView }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.QUALIFIED_TEACHER">{{lang.qualifiedTeachers }}</a>
          </li>
          <li>
            <span *ngIf="single_data">{{ single_data.fname }}  {{ single_data.lname }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <!-- <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a> -->

            <a class="plus-edit" [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER_EDIT+'/'+this.id]"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="selectedTab == 'generalData' ? 'active' : 'none'"><a href="#generalTab"
                      aria-controls="feedTab" role="tab" data-toggle="tab">{{ lang.generalData }}</a></li>

                  <li role="presentation" [ngClass]="selectedTab == 'coursesDelivered' ? 'active' : 'none'"><a href="#coursesDelivered"
                      aria-controls="coursesDelivered" role="tab" data-toggle="tab">{{
                      lang.coursesDelivered }}</a></li>


                  <li role="presentation" [ngClass]="selectedTab == 'dynamicEvaluation' ? 'active' : 'none'"><a href="#dynamicEvaluation" aria-controls="dynamicEvaluation" role="tab"
                      data-toggle="tab">{{
                      lang.dynamicEvaluation }}</a></li>

                </ul>

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">
                    <div class="tab-content">
                      <div class="tab-pane in active" id="panel_tab3_example1">


                        <div class="panel panel-default">

                          <div class="panel-heading">
                            Teacher Details </div>

                          <div class="panel-body">



                            <div class="col-sm-12 nopaddno">

                              <div class="col-sm-6 paleft">
                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.name }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.fname }}">
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-6 paright">
                                <div class="form-group">
                                  <label class="col-sm-12 control-label">{{ lang.surname }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.lname }}">
                                  </div>
                                </div>
                              </div>

                            </div>

                            <div class="col-sm-12 nopaddno">

                              <div class="col-sm-6 paleft">
                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.company }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.company }}">
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-6 paright">
                                <div class="form-group">
                                  <label class="col-sm-12 control-label">{{ lang.telephone }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.telephone }}">
                                  </div>
                                </div>
                              </div>

                            </div>

                            <div class="col-sm-12 nopaddno">

                              <div class="col-sm-6 paleft">
                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.email }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.email }}">
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-6 paright">
                                <div class="form-group">
                                  <label class="col-sm-12 control-label">{{ lang.fiscalCode }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.fiscal_code }}">
                                  </div>
                                </div>
                              </div>

                            </div>

                            <div class="col-sm-12 nopaddno">

                              <div class="col-sm-6 paleft">
                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.taxCode }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.tax_code }}">
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-6 paright">
                                <div class="form-group">
                                  <label class="col-sm-12 control-label">{{ lang.address }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.address }}">
                                  </div>
                                </div>
                              </div>

                            </div>

                            <div class="col-sm-12 nopaddno">

                              <div class="col-sm-6 paleft">
                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.city }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.city }}">
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-6 paright">
                                <div class="form-group">
                                  <label class="col-sm-12 control-label">{{ lang.state }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.state }}">
                                  </div>
                                </div>
                              </div>

                            </div>

                            <div class="col-sm-12 nopaddno">

                              <div class="col-sm-6 paleft newrow-01">

                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.zipcode }}</label>
                                  <div class="col-sm-12">
                                    <input class="form-control" type="text" value="{{ single_data.zip_code }}">
                                  </div>
                                </div>

                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.curriculumMaterial }}</label>
                                  <div class="col-sm-12">
                                    <div style="border: 1px solid #D5D5D5;min-height: 32px;">
                                      <span style="padding: 10px 5px;display: block;">
                                        <div *ngFor='let attach of single_data.curricula_material.split(",")'>
                                          <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{attach}}"
                                            target="_blank">{{attach}}</a>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.identityPapers }}</label>
                                  <div class="col-sm-12">
                                    <div style="border: 1px solid #D5D5D5;min-height: 32px;">
                                      <span style="padding: 10px 5px;display: block;">
                                        <div *ngFor='let attach of single_data.identity_papers.split(",")'>
                                          <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{attach}}"
                                            target="_blank">{{attach}}</a>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>


                                <div class="form-group normal_div">
                                  <label class="col-sm-12 control-label">{{ lang.contract }}</label>
                                  <div class="col-sm-12">
                                    <div style="border: 1px solid #D5D5D5;min-height: 32px;">
                                      <span style="padding: 10px 5px;display: block;">
                                        <div *ngFor='let attach of single_data.contract.split(",")'>
                                          <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{attach}}"
                                            target="_blank">{{attach}}</a>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>



                              </div>

                              <div class="col-sm-6 paright upload-formimg">
                                <div class="form-group">
                                  <label class="col-sm-12 control-label"> {{ lang.generalNotes }} </label>
                                  <div class="col-sm-12">
                                    <textarea class="form-control" rows="12">{{ single_data.general_notes }}</textarea>
                                  </div>
                                </div>

                                <div class="upload-formimg1">
                                  <img width="150px" height="160px" src="{{ single_data.image_file }}"
                                    class="image-responsive thumbnail">
                                </div>


                              </div>

                            </div>

                          </div>

                        </div>


                        <div class="panel panel-default">
                          <div class="panel-heading">{{ lang.skills }}</div>
                          <div class="panel-body ">
                            <div class="table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th>{{ lang.catalogueCode }}</th>
                                    <th>{{ lang.courseTitle }} </th>
                                    <th>{{ lang.category }}</th>
                                    <th>{{ lang.scopeofTeaching }}</th>
                                    <th>{{ lang.basicLevel }}</th>
                                    <th>{{ lang.currentLevel }}</th>
                                    <th>{{ lang.qualificationDate }}/th>
                                    <th>{{ lang.available }} </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let record of skills_data1 let i = index"
                                    id="{{record.qualified_teacheId}}">
                                    <td><a
                                        href="http://vmi313621.contaboserver.net/Software_demo/academy/catalog_view/{{ record.catalogue_code }}">{{
                                        record.cat_code }}</a></td>
                                    <td>{{ record.cat_course_name }}</td>
                                    <td>{{ record.cat_course_catg }}</td>
                                    <td>{{ record.require_level }}</td>
                                    <td>{{ record.level }}</td>
                                    <td>{{ record.current_level }}</td>
                                    <td>{{ record.qualification_date }}</td>
                                    <td>{{ record.status }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>

                    </div>


                  </div>


                  <div role="tabpanel" class="tab-pane" id="coursesDelivered">
                    <div class="row p-10">

                      <div class="col-sm-2" >
                        <div class="social-icons">
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        </div>
                      </div>

                      <div  class="col-sm-10">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div> 

                    </div>
                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="tab_details2">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>S/N</th>
                            <th>{{ lang.catalogueCode }}</th>
                            <th>{{ lang.catalogCode }}</th>
                            <th>{{ lang.courseTitle }} </th>
                            <th>{{ lang.coursesCategory }}</th>
                            <th>{{ lang.durationHours }}</th>
                            <th>{{ lang.endDate }}</th>
                            <th>{{ lang.startDate }}</th>
                            <th>{{ lang.customer }}</th>
                            <th>{{ lang.status }} </th>
                            <th>{{ lang.courseEvaluation }} </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let tab_record of tab_details2 let i = index" id="{{tab_record.schedule_id}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{ tab_record.course_code }}</td>
                            <td>{{ tab_record.catalog_code }}</td>
                            <td>{{ tab_record.course_title }}</td>
                            <td>{{ tab_record.course_category }}</td>
                            <td>{{ tab_record.duration }}</td>
                            <td>{{ tab_record.end_date }}</td>
                            <td>{{ tab_record.start_date }}</td>
                            <td>
                              <div *ngFor='let attach of tab_record.customer'>
                                <a href="http://vmi313621.contaboserver.net/Software_backend/customers/single_view/{{attach.item_id}}"
                                  target="_blank">{{attach.item_name}}</a>
                              </div>

                            </td>
                            <td>{{ tab_record.status }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>


                  </div>

                  <div role="tabpanel" class="tab-pane" id="dynamicEvaluation">
                    <h4>{{ lang.generalResume }}</h4>
                    <div class="table-responsive">
                      <div class="table-responsive">
                        <table class="table table-striped table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>{{ lang.instances }}</th>
                              <th>{{ lang.totalHours }}</th>
                              <th>{{ lang.totalAttendies }}</th>
                              <th>{{ lang.totalCourseScore }}</th>
                              <th>{{ lang.averageTeacherScore }}</th>

                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="clearfix"></div>

                      <div class="well well-sm">
                        <h4>Course 1 </h4>
                        <div class="table-responsive">
                          <div class="table-responsive">
                            <table class="table table-striped table-hover table-bordered">
                              <thead>
                                <tr>
                                  <th>{{ lang.catalogCode }}</th>
                                  <th>{{ lang.courseTitle }} </th>
                                  <th>{{ lang.category }}</th>
                                  <th>{{ lang.totalAttendies }}</th>
                                  <th>{{ lang.totalHours }}</th>
                                  <th>{{ lang.totalCourseScore }}</th>
                                  <th>{{ lang.averageTeacherScore }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let record of skills_data1 let i = index"
                                  id="{{record.qualified_teacheId}}">
                                  <td><a
                                      href="http://vmi313621.contaboserver.net/Software_demo/academy/catalog_view/{{ record.catalogue_code }}">{{
                                      record.cat_code }}</a></td>
                                  <td>{{ record.cat_course_name }}</td>
                                  <td>{{ record.cat_course_catg }}</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="clearfix">
                          </div>

                          <div class="table-responsive">
                            <div class="table-responsive">
                              <table class="table table-striped table-hover table-bordered">
                                <thead>
                                  <tr>
                                    <th>{{ lang.instances }}</th>
                                    <th>{{ lang.startDate }}</th>
                                    <th>{{ lang.endDate }}</th>
                                    <th>{{ lang.status }}</th>
                                    <th>{{ lang.customer }}</th>
                                    <th>{{ lang.attendies }}</th>
                                    <th>{{ lang.hour }}</th>
                                    <th>{{ lang.courseScore }}</th>
                                    <th>{{ lang.teacherScore }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                   <tr *ngFor="let drecord of dynamic let i = index">
                                    <td>{{ i+1 }}</td>
                                    <td class="start_date">{{ drecord.sc_date }}</td>
                                    <td class="end_date">{{ drecord.end_date }}</td>
                                    <td>{{ drecord.status }}</td>
                                    <td>{{ drecord.customer }}</td>
                                    <td>{{ drecord.attendies }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="clearfix">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</section>

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ emplang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ emplang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ emplang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
         -->
      <div class="modal-header">
        <h4 class="modal-title pull-left">Import Employee Data</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>

            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_customers_employees.csv">Click
                  Here</a> {{ emplang?.todownloadtocsv}}</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button type="button" class="btn btn-primary" (click)="onclick(this.id)">{{ emplang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ clang?.export }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <!-- <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
                (change)="export3_select_deselect_all($event)"><i></i> {{ clang?.selectAll }} </label> -->
        </div>
        <div class="row flexs">

          <div class="active-left">
            <!-- <h2>{{ clang?.activeColumns }}</h2> -->

            <!-- <div class="row" *ngFor="let option of datatableCols3">
                <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                  <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                    (change)="export3_select_deselect($event)"><i></i> {{option.value}}
                </label>
              </div> -->
            <div id="datatableExportBtn3" class="export_dynamic_btn">


            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="export_dynamic_btn">
          </div>
          <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ alang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ alang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ plang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i> {{ plang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ plang?.close }}</button>
      </div>

    </div>
  </div>
</div>